import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ContainerHeader from 'components/common/ContainerHeader';

import {containerStyles, colors} from 'styles/shared';

const MonthlyRevenueContainer = styled.div`
  position: relative;
  width: 36.1rem;
  height: 39.5rem;
  padding: 5rem 5rem 0;
  margin-bottom: 5rem;
  z-index: 10;
  ${containerStyles};
`;

const AmountContainer = styled.div`
  width: 14.6rem;
  height: 5rem;
  background: white;
  box-shadow: 0 1.2rem 2.6rem rgba(199, 196, 218, 0.5);
  font-weight: bold;
  font-size: 2.6rem;
  line-height: 3.9rem;
  letter-spacing: 0.02rem;
  color: ${colors.green_dark};
  margin-top: 1.5rem;
  border-radius: 12.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

MonthlyRevenue.propTypes = {
  total: PropTypes.number.isRequired
};

function MonthlyRevenue({total}) {
  let displayTotal = total.toLocaleString();

  function render() {
    return (
      <MonthlyRevenueContainer>
        <ContainerHeader>Monthly revenue</ContainerHeader>

        <AmountContainer>${displayTotal}</AmountContainer>
      </MonthlyRevenueContainer>
    );
  }

  return render();
}

export default MonthlyRevenue;
